document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.stacked-banner-slider');

  sliders.forEach((slider) => {
    const sliderTrack = slider.querySelector('.stacked-slider');
    const nextBtn = slider.querySelector('.stacked-next');
    const prevBtn = slider.querySelector('.stacked-prev');

    if (!sliderTrack) return;

    const slides = Array.from(sliderTrack.querySelectorAll('.stacked-slide'));

    let currentIndex = 0;
    const MAX_VISIBLE = window.stackedSliderConfig?.maxVisible || 4;

    function updateSlider() {
  const total = slides.length;

  slides.forEach((slide, index) => {
    // Wrap position so slides cycle: 0, 1, 2, 0, 1, 2...
    const position = (index - currentIndex + total) % total;

    slide.dataset.index = position;

    if (position === 0) {
      slide.style.pointerEvents = 'auto';
    } else {
      slide.style.pointerEvents = 'none';
    }

    if (position >= MAX_VISIBLE) {
      slide.style.opacity = '0';
    } else {
      slide.style.opacity = '1';
    }
  });

  if (prevBtn) prevBtn.disabled = currentIndex === 0;
  if (nextBtn) nextBtn.disabled = currentIndex === slides.length - 1;
}
    let isAnimating = false;

    function runSlide(change) {
        if (isAnimating) return;

        const nextIndex = currentIndex + change;

        if (nextIndex < 0 || nextIndex >= slides.length) return;

        isAnimating = true;
        currentIndex = nextIndex;

        updateSlider();

        const onDone = () => {
            isAnimating = false;
            sliderTrack.removeEventListener('transitionend', onDone);
        };

        sliderTrack.addEventListener('transitionend', onDone);

        // fallback safety
        setTimeout(() => { isAnimating = false;}, 500);
    }

    function nextSlide() {
        runSlide(1);
    }

    function prevSlide() {
        runSlide(-1);
    }

    // Button events
    nextBtn?.addEventListener('click', nextSlide);
    prevBtn?.addEventListener('click', prevSlide);

    // Touch handling (improved)
    let startX = 0;
    let touchLocked = false;

    sliderTrack.addEventListener('touchstart', (e) => {
      if (isAnimating) return;
      startX = e.touches[0].clientX;
      touchLocked = false;
    });

    sliderTrack.addEventListener('touchmove', () => {
      touchLocked = true;
    });

    sliderTrack.addEventListener('touchend', (e) => {
      if (isAnimating || touchLocked) return;

      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;

      if (Math.abs(diff) < 50) return;

      if (diff > 0) nextSlide();
      else prevSlide();
    });

    updateSlider();
  });
});